import loadable from '@wix/yoshi-flow-editor/loadable'

export const DesktopTicketsPicker = loadable(
  async () => import(/* webpackChunkName: "tickets-picker" */ './desktop-tickets-picker'),
)

export const MobileTicketsPicker = loadable(
  async () => import(/* webpackChunkName: "mobile-tickets-picker" */ './mobile-tickets-picker'),
)
